module.exports=function(scope){ return `curl -X GET \
 https://<ZOOM_LICENSING_URL_PROVIDED_BY_FACETEC> \
 -H 'cache-control: no-cache' \
 -H 'x-api-key: <ZOOM_LICENSING_API_KEY_PROVIDED_BY_FACETEC>'
`};


// WEBPACK FOOTER //
// ./src/resources/code/wildcard-licenses/bash/licensing.bash.tpl